/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { BillingRulesFormCustomer } from "~/components/BillingRules/BillingRulesFormCustomer";
import { useCustomer } from "~/context/User/Customer";
import { useUserConsumer } from "~/context/User/User";
import { isStandardUser } from "~/routing";

function BillingRules() {
  const { customer, fetchCustomer } = useCustomer();

  const { role } = useUserConsumer();
  const canEdit = isStandardUser(role);

  return (
    <div>
      <BillingRulesFormCustomer
        customer={customer}
        refetch={fetchCustomer}
        canEdit={canEdit}
      />
    </div>
  );
}

export { BillingRules };
